import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { config } from '#services/config';
const FlagProvider = dynamic(() => import('@unleash/proxy-client-react'), {
  ssr: false
});
export const UnleashProvider: FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FlagProvider config={config.unleash}>{children}</FlagProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};